import { MicrosoftLogo } from './MicrosoftLogo'
import type { MicrosoftSignInButtonProps } from './MicrosoftSignInButton.types'
import './MicrosoftSignInButton.css'

export function MicrosoftSignInButton({ onClick }: MicrosoftSignInButtonProps) {
  return (
    <button type="button" onClick={onClick} className="msft-btn">
      <MicrosoftLogo />
      <span>Sign in with Microsoft</span>
    </button>
  )
}
